import React from 'react';
import { Quote } from 'lucide-react';

const TraderStory = () => {
  return (
    <section style={{
      padding: '120px 7.6923%',
      background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background accent */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '800px',
        height: '800px',
        background: 'radial-gradient(circle, rgba(227, 24, 55, 0.05) 0%, transparent 70%)',
        pointerEvents: 'none'
      }}></div>

      <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Quote icon */}
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 32px',
          background: 'linear-gradient(135deg, rgba(227, 24, 55, 0.2), rgba(227, 24, 55, 0.05))',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid rgba(227, 24, 55, 0.3)'
        }}>
          <Quote style={{ 
            width: '40px', 
            height: '40px', 
            color: '#E31837',
            transform: 'rotate(180deg)'
          }} />
        </div>

        {/* Eyebrow */}
        <p style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#E31837',
          textTransform: 'uppercase',
          letterSpacing: '2px',
          fontWeight: 600,
          marginBottom: '24px'
        }}>
          Kisah Nyata Trader Indonesia
        </p>

        {/* Main title */}
        <h2 style={{
          fontSize: window.innerWidth <= 768 ? '28px' : '42px',
          fontWeight: 700,
          color: '#FFFFFF',
          textAlign: 'center',
          marginBottom: '48px',
          lineHeight: 1.3,
          fontFamily: "'Montserrat', sans-serif"
        }}>
          "3 Tahun Trading, Belum Pernah Sekali pun Withdraw Profit"
        </h2>

        {/* Story content */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.02)',
          border: '1px solid rgba(227, 24, 55, 0.2)',
          borderRadius: '16px',
          padding: window.innerWidth <= 768 ? '32px 24px' : '48px 40px',
          backdropFilter: 'blur(10px)'
        }}>
          {/* Intro paragraph */}
          <p style={{
            fontSize: '18px',
            lineHeight: 1.8,
            color: 'rgba(255, 255, 255, 0.9)',
            marginBottom: '32px',
            fontStyle: 'italic'
          }}>
            Nama saya Rizky. Umur 34 tahun. Manager di sebuah perusahaan IT di Jakarta Selatan. 
            Gaji lumayan, tapi ya gitu... bayar cicilan rumah, anak 2, biaya hidup Jakarta mahal. 
            Tabungan mentok-mentok segitu aja.
          </p>

          {/* Divider */}
          <div style={{
            width: '60px',
            height: '3px',
            background: 'linear-gradient(90deg, transparent, #E31837, transparent)',
            margin: '32px auto'
          }}></div>

          {/* Main story */}
          <div style={{ marginBottom: '32px' }}>
            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Tahun 2021, saya mulai belajar trading. Baca buku, ikut webinar gratis, join grup Telegram 
              yang katanya "guaranteed profit". Deposit pertama Rp 10 juta dari tabungan. 
              <span style={{ color: '#E31837', fontWeight: 600 }}> Habis dalam 2 minggu.</span>
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Saya pikir, "Gua belum belajar cukup nih." Jadi saya beli course, bayar Rp 5 juta. 
              Belajar support resistance, candlestick pattern, fibonacci, moving average... semua. 
              Deposit lagi Rp 15 juta.{' '}
              <span style={{ color: '#E31837', fontWeight: 600 }}>
                Bulan pertama profit Rp 3 juta. Bulan kedua loss Rp 8 juta.
              </span>
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Yang paling sakit? Istri mulai tanya-tanya. "Mas, uang tabungan kemana?" 
              Saya bohong. Bilang ada investasi bagus. Tapi dalam hati, saya stress banget.
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px',
              background: 'rgba(227, 24, 55, 0.05)',
              padding: '20px',
              borderLeft: '4px solid #E31837',
              borderRadius: '4px'
            }}>
              <strong style={{ color: '#FF1744' }}>Selama 3 tahun, saya deposit total Rp 87 juta.</strong><br/>
              Withdraw? Nol. Nihil. Semua habis buat "belajar". Atau lebih tepatnya... loss.
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Setiap malem jam 11 keatas, saya masih di depan laptop. Analisa chart. 
              Baca news. Setup trade untuk besok. Istri udah tidur. Anak-anak tidur. 
              Saya? Masih bengong liat chart XAUUSD, EURUSD, GBPUSD... 
              <span style={{ fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.6)' }}>
                sambil ngarep, "Besok pasti profit nih."
              </span>
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Tapi besoknya? Floating minus lagi. Stop loss kena lagi. Margin call lagi.
            </p>
          </div>

          {/* Divider */}
          <div style={{
            width: '60px',
            height: '3px',
            background: 'linear-gradient(90deg, transparent, #E31837, transparent)',
            margin: '32px auto'
          }}></div>

          {/* Turning point */}
          <div style={{ marginBottom: '32px' }}>
            <p style={{
              fontSize: '19px',
              lineHeight: 1.9,
              color: '#FFFFFF',
              marginBottom: '24px',
              fontWeight: 600
            }}>
              November 2024. Saya hampir nyerah total.
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Terus ada temen kantor, namanya Budi. Dia cerita dia udah 6 bulan pake copy trading. 
              Saya skeptis. Saya pikir, "Ah, copy trading mah sama aja gambling. 
              Ikut orang lain yang juga gak pasti menang."
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Tapi Budi bukan tipe orang yang sombong. Dia show dashboard broker dia. 
              <span style={{ color: '#10B981', fontWeight: 600 }}>
                {' '}Balance naik dari Rp 12 juta jadi Rp 19 juta dalam 5 bulan.
              </span>{' '}
              Gak gede-gede amat, tapi konsisten. Dan yang penting... dia bilang dia udah 
              <span style={{ color: '#10B981', fontWeight: 600 }}> withdraw 2 kali. Total Rp 4 juta.</span>
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px',
              fontStyle: 'italic'
            }}>
              "Mas Rizky, gua gak pernah liat chart lagi. Gak pernah stress mikirin market. 
              Sistemnya jalan sendiri. Gua cuma check seminggu sekali doang."
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Jujur, saya tertarik. Tapi takut juga. Uang tabungan udah habis banyak. 
              Kalau rugi lagi... saya gak tau mau ngomong apa ke istri.
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Tapi saya pikir, "Udah 3 tahun gua manual trading, hasilnya NOL. 
              Kenapa gak coba cara lain?"
            </p>
          </div>

          {/* Divider */}
          <div style={{
            width: '60px',
            height: '3px',
            background: 'linear-gradient(90deg, transparent, #E31837, transparent)',
            margin: '32px auto'
          }}></div>

          {/* Resolution */}
          <div>
            <p style={{
              fontSize: '19px',
              lineHeight: 1.9,
              color: '#FFFFFF',
              marginBottom: '24px',
              fontWeight: 600
            }}>
              Desember 2024. Saya coba Sahara AI.
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Deposit Rp 10 juta. Sisa-sisa tabungan yang masih ada. 
              Saya pilih strategi yang risk level rendah. Copy otomatis. Dan saya... tunggu aja.
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              <span style={{ color: '#10B981', fontWeight: 600 }}>
                Minggu pertama: +Rp 780 ribu.<br/>
                Minggu kedua: +Rp 1,2 juta.<br/>
                Bulan pertama total: +Rp 3,1 juta.
              </span>
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Gak banyak? Iya. Tapi buat saya? <strong style={{ color: '#FFFFFF' }}>Ini pertama 
              kalinya dalam 3 tahun saya trading, saya ngerasain profit yang stabil.</strong>
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px',
              background: 'rgba(16, 185, 129, 0.1)',
              padding: '20px',
              borderLeft: '4px solid #10B981',
              borderRadius: '4px'
            }}>
              <strong style={{ color: '#10B981' }}>
                Januari 2025. Saya withdraw pertama kali. Rp 2 juta.
              </strong><br/>
              Uang masuk rekening dalam 1 hari. Saya kasih ke istri. 
              Saya bilang jujur, "Ini dari trading. Kali ini beda. Kali ini beneran."
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Istri saya cuma senyum. Dia bilang, "Alhamdulillah, Mas. Syukurin aja. Jangan nafsu lagi ya."
            </p>

            <p style={{
              fontSize: '17px',
              lineHeight: 1.9,
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}>
              Sekarang? Saya udah gak liat chart lagi. Gak stress lagi. 
              Jam 11 malem? Saya tidur. Gak ada lagi begadang depan laptop. 
              Weekend? Main sama anak. Bukan analisa chart.
            </p>

            <p style={{
              fontSize: '18px',
              lineHeight: 1.9,
              color: '#FFFFFF',
              marginBottom: '0',
              fontWeight: 600,
              textAlign: 'center',
              marginTop: '32px'
            }}>
              Untuk pertama kalinya dalam 3 tahun... saya merasa tenang.
            </p>
          </div>
        </div>

        {/* Closing note */}
        <div style={{
          marginTop: '48px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '15px',
            color: 'rgba(255, 255, 255, 0.6)',
            fontStyle: 'italic',
            marginBottom: '16px'
          }}>
            — Rizky Hartawan, Jakarta Selatan
          </p>
          <p style={{
            fontSize: '13px',
            color: 'rgba(255, 255, 255, 0.4)',
            fontStyle: 'italic',
            lineHeight: 1.6
          }}>
            *Cerita ini berdasarkan pengalaman pengguna. Hasil trading bervariasi untuk setiap individu.<br/>
            Performa masa lalu tidak menjamin hasil di masa depan. Trading melibatkan risiko.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TraderStory;
